import script from "./project-list.vue?vue&type=script&setup=true&lang=js"
export * from "./project-list.vue?vue&type=script&setup=true&lang=js"

import "./project-list.vue?vue&type=style&index=0&id=a6a9d914&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a6a9d914"]])

export default __exports__